import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

//#region src/lib/utils.ts
/**
* Merges class names with Tailwind CSS class conflict resolution
* @param inputs - Class names to merge
* @returns Merged class string
*/
function cn(...inputs) {
	return twMerge(clsx(inputs));
}
const compactNumberFormatter = new Intl.NumberFormat("en", {
	notation: "compact",
	maximumFractionDigits: 1
});
/**
* Compact number formatting for axis ticks / KPI tiles, e.g. 1234 -> "1.2K",
* 15000 -> "15K", 1500000 -> "1.5M".
*/
function formatCompactNumber(value) {
	if (typeof value !== "number" || Number.isNaN(value)) return "0";
	return compactNumberFormatter.format(value);
}

//#endregion
export { cn, formatCompactNumber };
//# sourceMappingURL=utils.mjs.map